<script>
import {
  pageMonCompteMesCommandesEnMagasinEmits,
  pageMonCompteMesCommandesEnMagasinProps,
  usePageMonCompteMesCommandesEnMagasin
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import CommandeMagasinOverview from "@/components/organisms/mon-compte/commande-magasin-overview/default";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";
import MesAchatsFilters from "@/components/organisms/mon-compte/mes-achat-filters/default";
import AppliedFilters from "@/components/organisms/product-list/product-list-header/applied-filters/default";
import Icon from "@/components/atoms/icon";
import LoadingSpinner from "@/components/molecules/loading-spinner";
import LinkTo from "@/components/atoms/link-to";
import BandeauCommandeEnLigne from "@/components/organisms/bandeau-commande/bandeau-commande-enligne";
import BandeauCommandeMagasin from "@/components/organisms/bandeau-commande/bandeau-commande-magasin";

import noResult from "@/assets/images/mon-compte-achat/no-result.svg";
import teasing from "@/assets/images/mon-compte-achat/teasing.svg";
import noAchat from "@/assets/images/mon-compte-achat/no-achat.svg";
import register from "@/assets/images/mon-compte-achat/register.svg";
import carrefourLoyaltyPassOmbre from "@/assets/images/carrefour-club-pass-card-ombre-incline.svg";

export default {
  name: "MesCommandesEnMagasin",
  components: {
    List,
    BandeauCommandeEnLigne,
    BandeauCommandeMagasin,
    ListItem,
    CommandeMagasinOverview,
    Button,
    LazyImage,
    Card,
    Titre,
    MesAchatsFilters,
    AppliedFilters,
    Icon,
    LinkTo,
    LoadingSpinner
  },
  props: {
    ...pageMonCompteMesCommandesEnMagasinProps()
  },
  emits: [
    "supprimerToutFiltres",
    "voirPlusAchats",
    ...pageMonCompteMesCommandesEnMagasinEmits()
  ],
  setup(props, context) {
    const {
      libellePeriode,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      appliquerFiltre,
      supprimerFiltre,
      setPopinAjoutCarte,
      setPeriodeLibelle,
      canDisplayBanner
    } = usePageMonCompteMesCommandesEnMagasin(context, props);

    return {
      canDisplayBanner,
      libellePeriode,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      appliquerFiltre,
      supprimerFiltre,
      setPopinAjoutCarte,
      setPeriodeLibelle,
      noResult,
      teasing,
      noAchat,
      register,
      carrefourLoyaltyPassOmbre
    };
  }
};
</script>

<template>
  <BandeauCommandeMagasin v-if="canDisplayBanner" />

  <div>
    <div
      v-if="filtersDisplay"
      class="u-mt-lg"
    >
      <p class="u-font-14 u-font-700">
        Filtrer :
      </p>
      <MesAchatsFilters
        ref="achatFiltres"
        class="u-mt-xs"
        :liste-magasins="listeMagasins"
        :query-filters="queryFilters"
        :libelle-periode-setted="libellePeriode"
        :key-periode="keyPeriode"
        @supprimerFiltre="supprimerFiltre"
        @appliquerFiltres="appliquerFiltre"
        @setPeriodeLibelle="setPeriodeLibelle"
      />
      <AppliedFilters
        v-if="appliedFilters"
        :applied-filters="appliedFilters"
        class="u-mt-md"
        key-code
        @select="supprimerFiltre"
        @initiateProductFilter="$emit('supprimerToutFiltres')"
      />
    </div>

    <div
      v-if="achatsMagasin.length > 0 || achatIsLoading"
      class="u-pt-lg"
    >
      <List
        v-for="achat in achatsMagasin"
        :key="achat.id"
        class="u-mb-md"
      >
        <ListItem class="u-mb-sm">
          <CommandeMagasinOverview :commande="achat" />
        </ListItem>
      </List>
      <LoadingSpinner
        v-if="achatIsLoading"
        size="md"
      />
      <div
        v-if="showSeeMoreResults"
        class="u-text-center"
      >
        <Button
          variant="primary"
          radius="full"
          size="md"
          @click="$emit('voirPlusAchats')"
        >
          Voir plus d’achats
        </Button>
      </div>
    </div>
    <Card
      v-if="!achatIsLoading && achatsMagasin.length === 0"
      elevation="sm"
      radius="md"
      class="u-mt-md"
    >
      <div class="u-px-md u-py-lg">
        <div
          v-if="isFidCarrefour"
          class="u-flex u-flex-align-center"
        >
          <LazyImage
            :src="carrefourLoyaltyPassOmbre"
            width="119"
            height="90"
            class="u-inline-block u-flex-shrink-none u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
            >
              Vous ne voyez pas vos achats effectués en magasin ?
            </Titre>
            <p class="u-font-15 u-mt-xs u-mb-sm">
              Retrouvez vos tickets de caisse sur les achats effectués en magasin avec votre Carte Club ou Carte PASS sur <LinkTo to="#">carrefour.fr
                <Icon
                  name="external"
                  size="sm"
                />
              </LinkTo>
            </p>
          </div>
        </div>
        <div
          v-else-if="error && error !== 404"
          class="u-flex u-flex-align-start"
        >
          <Icon
            variant="alert"
            name="alert-circle-outline"
            size="lg"
            class="u-flex-shrink-none u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-mb-xs"
            >
              Désolé, une erreur s’est produite
            </Titre>
            <p class="u-font-15">
              Nous n’avons pas réussi à récupérer vos tickets de caisse magasin. Veuillez réessayer plus tard
            </p>
          </div>
        </div>
        <div
          v-else-if="achatsMagasin.length === 0 && appliedFilters.length == 0 && queryFilters.garantie === '0' || error === 404"
          class="u-flex u-flex-align-start"
        >
          <LazyImage
            :src="noAchat"
            width="135"
            class="u-inline-block u-mr-md"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-mb-xs"
            >
              Vous n’avez pas encore effectué d’achat en présentant votre carte en magasin
            </Titre>
            <p class="u-font-15">
              Réglez avec votre carte cora Cpay Mastercard ou présentez votre carte Malin lors de votre passage en caisse, pour retrouver vos tickets de caisse dans cette page.
            </p>
          </div>
        </div>

        <div
          v-else-if="isMagasinTeasing"
          class="u-flex u-flex-align-start"
        >
          <LazyImage
            :src="teasing"
            width="85"
            class="u-inline-block u-mr-lg"
          />
          <div>
            <Titre
              tag="h2"
              size="sm"
              class="u-mb-xs"
            >
              Bientôt disponible
            </Titre>
            <p class="u-font-15">
              Tous vos prochains tickets de caisse seront disponibles ici en présentant votre carte Malin ou en réglant avec votre carte cora Cpay Mastercard en magasin.
            </p>
          </div>
        </div>

        <div
          v-else-if="achatsMagasin.length === 0 && (appliedFilters.length > 0 || queryFilters.garantie === '1')"
          class="u-flex u-flex-align-start"
        >
          <LazyImage
            :src="noResult"
            width="90"
            class="u-inline-block u-mr-md"
          />
          <div>
            <div>
              <Titre
                tag="h2"
                size="sm"
                class=""
              >
                Nous n’avons pas trouvé de ticket de caisse correspondant à vos filtres
              </Titre>
              <div class="u-flex u-flex-align-center u-mt-sm">
                <Icon
                  name="info-circle"
                  variant="primary-light"
                  size="sm"
                  class="u-flex-shrink-none u-mr-xs"
                />
                <p class="u-color-text-light u-font-14">
                  Vos tickets de caisse sont conservés pendant une durée de 2 ans
                </p>
              </div>
            </div>

            <div class="u-mt-lg">
              <Button
                size="md"
                radius="full"
                variant="primary"
                @click="$emit('supprimerToutFiltres')"
              >
                <span class="u-font-500">Réinitialiser les filtres</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>
